import React from "react";
const loginMessages = {
  "no-user": {
    type: "error",
    icon: "shield-exclamation",
    message: (
      <>
        Actualmente no estás inscrito en la plataforma.{" "}
        <strong>
          Comunícate con el administrador de la tienda para tu inscripción.
        </strong>
      </>
    ),
  },
  "user-error": {
    type: "error",
    icon: "shield-exclamation",
    message: (
      <>
        No se pudo realizar la solicitud.{" "}
        <strong>Comunícate con el administrador de la tienda.</strong>
      </>
    ),
  },
  "no-pass": {
    type: "error",
    icon: "shield-exclamation",
    message:
      "Actualmente te encuentras inscrito en la plataforma pero no cuentas con una contraseña.",
  },
  "rule-email": {
    type: "error",
    icon: "shield-exclamation",
    message: "Ingresa un email correcto",
  },
  "rule-password": {
    type: "error",
    icon: "shield-exclamation",
    message: "Ingresa una contraseña",
  },
  "password-success": {
    type: "success",
    icon: "check",
    message: "Contraseña creada satisfactoriamente",
  },
  "bad-password": {
    type: "error",
    icon: "shield-exclamation",
    message: "Usuario o Contraseña incorrecta",
  },
  "bad-temp-password": {
    type: "error",
    icon: "shield-exclamation",
    message: "Contraseña temporal incorrecta",
  },
  "Attempt-limit-exceeded": {
    type: "error",
    icon: "shield-exclamation",
    message:
      "Ha intentado restablecer la contraseña demaciadas veces",
    description:"Intenta luego de una hora aproximadamente"
  },
  "invalid-password-exception": {
    type: "error",
    icon: "shield-exclamation",
    message: "La contraseña no cumple con la politica de seguridad",
  },
  "bad-code-password": {
    type: "error",
    icon: "shield-exclamation",
    message: "Código de verificación incorrecto",
  },
  "required-code": {
    type: "error",
    icon: "shield-exclamation",
    message: "Este campo es obligatorio",
  },
  "password-equals": {
    type: "error",
    icon: "shield-exclamation",
    message: "Las contraseñas no coinciden",
  },
  "rule-password-politics": {
    type: "error",
    icon: "shield-exclamation",
    message: "Las contraseñas no coinciden",
  },
  "send-email-success": {
    type: "success",
    icon: "check",
    message: "El codigo de verificacion ha sido enviado correctamente",
  },
  "user-limited-recovery": {
    type: "error",
    icon: "shield-exclamation",
    message: (
      <>
        Has excedido el límite máximo.{" "}
        <strong>Inténtalo de nuevo, luego de una hora.</strong>
      </>
    ),
  },
};

const statusMessages = {
  noexists: "NO_EXISTS",
  forceChangePassword: "FORCE_CHANGE_PASSWORD",
  confirmed: "CONFIRMED",
  sms_mfa: "SMS-MFA",
  email_mfa: "EMAIL-MFA"
};

const mapStatus = {
  FORCE_CHANGE_PASSWORD: "Contraseña temporal",
  CONFIRMED: "Cuenta confirmada",
  "SMS-MFA": "MFA por SMS habilitado",
  "EMAIL-MFA": "MFA por Email habilitado",
};

export const strings = {
  ...loginMessages,
  ...statusMessages,
  ...mapStatus,
};

export const tables = {
  dependencies: {
    name: "dependencias-aplicacion",
    key: "almacennav",
  },
  registroapp: {
    name: "registro-aplicaciones",
    key: "idaplicacion",
  },
  rolesapp: {
    name: "roles-aplicacion",
    key: "idaplicacion",
    sortKey: "rol",
  },
  position: {
    name: "cargos-aplicacion",
    key: "idaplicacion",
    sortKey: "cargo",
  },
  appuser: {
    name: "yamaha-usuarios",
    key: "usuario",
    sortKey: "idaplicacion",
  },
  notification: {
    name: "yamaha-notificaciones",
    key: "id",
  },
  tiendas: {
    name: "yamaha-tiendas",
    key: "tienda",
  },
  ventas: {
    name: "yamaha-venta-asesores",
    key: "tienda",
    sortKey: "asesor",
  },
  userRequest: {
    name:"yamaha-solicitud-usuarios",
    key: "request_number",
  },
  appuserRequest: {
    name: "yamaha-solicitud-usuarios-aplicacion",
    key: "idsolicitud",
    sortKey: "idaplicacion",
  },
  businesslines: {
    name: "yamaha-lineas",
    key: "codigo",
    sortKey: "codigonav",
  },
  userdata: {
    name: "yamaha-usuarios-datos",
    key: "correo",
  },
  userrequestdata: {
    name: "yamaha-solicitud-datos",
    key: "correo",
  },
  userDataCognito: {
    name: "yamaha-usuarios-cognito",
    key: "correo",
  },
};
